import {FormProvider, useForm} from "react-hook-form";
import {CheckoutFormFormValues} from "../../../../../components/checkout-form/form/types";
import {yupResolver} from "@hookform/resolvers/yup";
import {Alert, Button, Col, Row, Space} from "antd";
import {StyledServiceButtonWrapper} from "../../../../../styles/onboarding/onboarding";
import {offeringCheckoutFormValidationSchema} from "../../../../../components/offering-form/general/checkout-form/validation-schema";
import {OfferingFormCheckoutFormValues} from "../../../../../components/offering-form/general/checkout-form/types";
import {useCreateLiveEventHook} from "../../hooks/create-live-event";
import {CreateLiveEventFormValues} from "../../reducers/create-live-event/types";
import {LiveEventCheckoutFormFields} from "../../../../../components/offering-form/live-events/checkout-form";
import {useCreateLiveEventContext} from "../../context/create-live-event";
import {useSyncCheckoutFormToContext} from "../../../../../utils/offering-create-draft";

export function CreateLiveEventCheckoutFormStep() {
  const {
    state: {formData, apiResponseData},
    dispatch,
  } = useCreateLiveEventContext();
  const checkoutFormMethods = useForm<OfferingFormCheckoutFormValues>({
    resolver: yupResolver(offeringCheckoutFormValidationSchema),
    mode: "onChange",
    defaultValues: formData,
  });
  useSyncCheckoutFormToContext({
    checkoutFormMethods,
    dispatch,
    saveActionType: "save-create-live-event-form-values",
    formData: {
      bookingQuestions: formData.bookingQuestions ?? [],
    },
  });
  // console.log({currentCreateLiveEventStep, apiResponseData});
  const {createLiveEvent, isCreatingLiveEvent} = useCreateLiveEventHook();
  function onSubmit(values: CheckoutFormFormValues) {
    if (apiResponseData) {
      dispatch({
        type: "go-to-cover-images-upload-form-step",
        payload: {
          apiResponse: apiResponseData,
          formData: {...formData, ...values},
        },
      });
      // console.log("i ran because i have apires");
    } else {
      const payload: CreateLiveEventFormValues = {
        ...formData,
        ...values,
      };
      createLiveEvent(payload);
    }
    // console.log({valuesMehn: values});
  }

  const isFormError = Object.keys(checkoutFormMethods.formState.errors).length > 0;
  const isBookingQuestionsError = checkoutFormMethods.formState.errors.bookingQuestions;

  return (
    <>
      <FormProvider {...checkoutFormMethods}>
        <form onSubmit={checkoutFormMethods.handleSubmit(onSubmit)} autoComplete="off">
          <Space size={16} direction="vertical" style={{display: "flex"}}>
            <LiveEventCheckoutFormFields
              isBookingQuestionsError={!!isBookingQuestionsError}
            />
            {isFormError && (
              <Alert
                message="Please fill in the required fields above, outlined in red"
                type="warning"
              />
            )}
            <Row gutter={[0, 16]}>
              <Col span={24} sm={12}>
                <StyledServiceButtonWrapper>
                  <Button
                    className="secondary-btn"
                    onClick={() =>
                      dispatch({
                        type: "go-to-basic-form-step",
                        payload: {
                          ...formData,
                          ...checkoutFormMethods.getValues(),
                        },
                      })
                    }
                    block
                    size="small"
                    type="default"
                  >
                    Back
                  </Button>
                  <Button
                    block
                    type="primary"
                    htmlType="submit"
                    size="small"
                    disabled={
                      Object.keys(checkoutFormMethods.formState.errors).length > 0 ||
                      Object.values(checkoutFormMethods.watch()).length < 1
                    }
                    loading={isCreatingLiveEvent}
                  >
                    Next
                  </Button>
                </StyledServiceButtonWrapper>
              </Col>
            </Row>
          </Space>
        </form>
      </FormProvider>
    </>
  );
}
